// extracted by mini-css-extract-plugin
export default {"CreateGoodTool":"CreateGoodTool_CreateGoodTool__SqlKL"};